<template>
    <div class="pane-template" v-if="tools.currentPaneKey === 'package'">
        <pane-header
            :title="package.title"
            :subtitle="package.sub"
            :tools="tools"
            v-if="!hideHeader"
            :appIconKey="package.type"
            :hasCloseIcon="true"
        />
        <ui-scrollable-container>
            <pane-content>
                <ui-details :title="package.title" :list="[
                    {
                        label: 'Holdings',
                        value: package.holdings,
                    },
                    {
                        label: 'Type',
                        value: package.type,
                    },
                    {
                        label: 'Hide all titles in this package',
                        value: package.hide_all_titles,
                    },
                    {
                        label: 'Allow EBSCO to add new titles',
                        value: package.allow_ebsco,
                    },
                    {
                        label: 'Source',
                        value: package.source,
                    },
                    {
                        label: 'Titles',
                        value: package.titles,
                    },
                    {
                        label: 'Vendor',
                        value: package.vendor,
                    },
                    {
                        label: 'Proxy server',
                        value: package.proxy_server,
                    },
                ]"></ui-details>
                <pane-section title="Related instances" preset="instance" :itemCount="package.instanceCount" :tools="tools" />
            </pane-content>
        </ui-scrollable-container>
    </div>
</template>

<script>
    export default {
        name: 'pane-package-template',
        props: ['tools', 'hideHeader'],
        computed: {
            package() {
                return this.tools.currentView.data.pane;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// PackagePaneTemplate.vue?4b6171e7